<app-job-notification-card
  (closeEvent)="onCloseClickedHandler()"
  [jobNotification]="pdfMergeNotification"
  [notificationIcon]="'svg_pdf_multiple'"
>
  <div notification-action-button>
    <app-print-action-buttons
      (downloadPdfButtonClickedEvent)="downloadPdfButtonClickedHandler()"
      (downloadZipButtonClickedEvent)="downloadZipButtonClickedHandler()"
      (openPdfButtonClickedEvent)="openPdfButtonClickedHandler()"
      [downloadPdfFlag]="true"
      [downloadZipFacturXBadgeFlag]="pdfMergeNotification.facturXBadgeFlag"
      [downloadZipFlag]="true"
      [downloadZipUblBadgeFlag]="pdfMergeNotification.ublBadgeFlag"
      [openPdfFlag]="true"
      class="floating-action-buttons"
    ></app-print-action-buttons>
  </div>
</app-job-notification-card>
